<template>
    <ac-modal title="Job Executor" ref="modalRef" :size-class="'modal-lg'">
        <template>
            <div class="row">
                <div class="col-xs-12">
                    <form>
                        <div class="row">
                            <div class="col-lg-12 info-board info-board-blue">
                                <p class="text-primary">
                                    Specify job name and arguments
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="commandAndArgs">Job Name</label>
                                        <input type="text" id="commandAndArgs" class="form-control"  v-model="jobName">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="JobArgs">Arguments</label>
                                        <input type="text" id="JobArgs" class="form-control" v-model="jobArguments">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <div class="button-box">
                            <span v-if="currentStatus">
                                <span class="alert alert-info">
                                    <span  v-if="jobStatusId === 1 || jobStatusId === 2"><i
                                            class="fa fa-lg fa-cog fa-spin"></i>
                                    </span>
                                    <span>
                                        {{currentStatus}}
                                    </span>
                                </span>
                            </span>
                            <ac-button class="btn btn-sm btn-red" :action="closeModal">Cancel</ac-button>
                            <ac-button class="btn btn-sm btn-green" :action="executeJob">Execute Job</ac-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "JobExecutorModal",
        data() {
            return {
                jobName: "",
                jobArguments: "",
                jobId: "",
                jobStatusId: "",
                currentStatus: ""
            };
        },
        methods: {
            showModal({jobArguments}) {
                this.jobArguments = jobArguments;
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async executeJob() {
                let jobData = {
                    name: this.jobName,
                    arguments: this.jobArguments
                }
                let result = await api.post('Job', 'Create', jobData);
                if(result) {
                    this.jobId = result.data.jobId;
                    this.getJobStatus();
                }
            },
            async getJobStatus() {
                var self = this;
                let data = await api.getData("Job", this.jobId, "GetDetails");
                this.currentStatus = data.statusName;
                this.jobStatusId = data.currentStatus;
                if (data.currentStatus !== 3 && data.currentStatus !== 4) {
                    setTimeout(function () {
                        self.getJobStatus();
                    }, 3000);
                }
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
</style>